import zhinenghua from "../img/photography.png";
import didaima from "../img/toilet.png";
import dashuju from "../img/transport.png";
import React from "react";

export const Customer00DataSource = {
    wrapper: {
        className: 'home-page-wrapper content0-wrapper k4niktbygd-editor_css',
    },
    page: { className: 'home-page content0' },
    OverPack: { playScale: -3, className: '' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [{ name: 'title', children: '客户案例' }],
        url: '/case',
    },
    childWrapper: {
        className: 'content0-block-wrapper',
        children: [
            {
                name: 'block0',
                className: 'content0-block',
                md: 6,
                xs: 6,
                children: {
                    className: 'content0-block-item',
                    positions: '智能化应用平台',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children:(
                                <img src={zhinenghua} alt="img"/>
                            ),
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: (
                                <>
                                    <p>智能应用</p>
                                </>
                            ),
                        },
                        {
                            name: 'content',
                            children: (
                                <>
                                    <p>影像后期智能服务平台</p>
                                </>
                            ),
                        },
                    ],
                },
            },
            {
                name: 'block2',
                className: 'content0-block',
                md: 6,
                xs: 6,
                children: {
                    className: 'content0-block-item',
                    positions: '大数据分析平台',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children: (
                                <img src={dashuju} alt="img"/>
                            ),
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: (
                                <>
                                    <p>大数据应用</p>
                                </>
                            ),
                        },
                        {
                            name: 'content',
                            children: (
                                <>
                                    <p>公共交通客流大数据应用</p>
                                </>
                            ),
                        },
                    ],
                },
            },
            {
                name: 'block~k4nj0q29cz',
                className: 'content0-block',
                md: 6,
                xs: 6,
                children: {
                    className: 'content0-block-item',
                    positions: '物联网应用平台',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children:(
                                <img src={didaima} alt="img"/>
                            ),
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: (
                                <>
                                    <p>物联应用</p>
                                </>
                            ),
                        },
                        {
                            name: 'content',
                            children:
                                <>
                                    <p>城市综合管理服务</p>
                                </>,
                        },
                    ],
                },
            },
        ],
    },
};
export default Customer00DataSource;